import React, { Component } from 'react';
import { Link } from 'react-router';
import { Button, Card, Col, Form, Input, message, Row, Table } from 'antd';
import { queryAbleBookInfo, queryBookInfoList } from '@api/finance/finance';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';

const FormItem = Form.Item;

const typeName = ['一般纳税人', '小规模纳税人'];

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      total: 0,
      pageNo: 1,
      isPermission: false,
    };
  }

  componentDidMount() {
    this.judge(this.props.account_info, () => {
      this.loadData(1);
    });
  }

  componentWillUnmount() {
    const { pageNo, condition } = this.state;
    const params = {
      pageNo,
      condition,
    };
    this.props.dispatch(setBackInfo(params));
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.account_info !== nextProps.account_info) {
      this.judge(nextProps.account_info);
    }
  }

  // 加载需公司账户信息数据
  loadData = pageNo => {
    const params = {};
    const { condition, isPermission } = this.state;

    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    if (!isPermission) {
      params.status = 1;
    }
    this.setState({
      pageNo: current,
      isLoading: true,
    });
    queryBookInfoList(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
        });
      }
    });
  };

  handleSubmit = e => {
    e.preventDefault();
    const { pageNo } = this.state;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState(
          {
            condition: values.condition,
          },
          () => {
            this.loadData(pageNo);
          },
        );
      }
    });
  };

  renderSearchForm = () => {
    const {
      form: { getFieldDecorator },
    } = this.props;
    const { condition } = this.state;
    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit} style={{ textAlign: 'right' }}>
          <FormItem>
            {getFieldDecorator('condition', {
              initialValue: condition || null,
            })(<Input placeholder="请输入关键字" />)}
          </FormItem>
          <FormItem>
            <Button htmlType="submit">查询</Button>
          </FormItem>
        </Form>
      </div>
    );
  };

  judge = (accountInfo, callback) => {
    const role = accountInfo.roles;
    let isPermission = false;
    role.forEach(item => {
      switch (item) {
        case '[CWManager]':
        case '[Caissier]':
          isPermission = true;
          break;
        default:
          break;
      }
    });
    if (accountInfo.admin) {
      isPermission = true;
    }

    this.setState(
      {
        isPermission,
      },
      callback,
    );
  };

  columns = () => {
    return [
      {
        title: '公司名称',
        dataIndex: 'compName',
      },
      {
        title: '纳税人识别号',
        dataIndex: 'taxpayerNumber',
      },
      {
        title: '开户行',
        dataIndex: 'bankName',
      },
      {
        title: '开户账号',
        dataIndex: 'bankBook',
      },
      {
        title: '地址',
        dataIndex: 'address',
      },
      {
        title: '电话',
        dataIndex: 'telephone',
      },
      {
        title: '类型',
        dataIndex: 'type',
        render: text => {
          return <span>{typeName[text]}</span>;
        },
      },

      {
        title: '操作',
        render: (text, record) => {
          const { isPermission } = this.state;
          return (
            <span>
              <Link to={`/finance/bookInfo/open/${record.uuid}`}>查看</Link>
              {isPermission ? <span className="ant-divider" /> : null}
              {isPermission ? <Link to={`/finance/bookInfo/edit/${record.uuid}`}>编辑</Link> : null}
              {isPermission ? <span className="ant-divider" /> : null}
              {isPermission ? (
                <a
                  href="#"
                  onClick={() => {
                    queryAbleBookInfo({
                      uuid: record.uuid,
                      status: record.status === 2 ? 1 : 2,
                    }).then(({ statusCode }) => {
                      if (statusCode === 200) {
                        message.success(`${record.status === 2 ? '启用' : '禁用'}成功`);
                        this.loadData();
                      }
                    });
                  }}
                >
                  {record.status === 2 ? '启用' : '禁用'}
                </a>
              ) : null}
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, isLoading, total, pageNo, isPermission } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <Row style={{ paddingBottom: '20px' }}>
            <Col span={13}>
              {isPermission ? (
                <Link to="/finance/bookInfo/add">
                  <Button type="primary">添加</Button>
                </Link>
              ) : null}
            </Col>

            <Col span={11}>
              <div className="tableListForm">{this.renderSearchForm()}</div>
            </Col>
          </Row>
        </div>
        <Table
          rowKey="uuid"
          loading={isLoading}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
      </Card>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
  account_info: state.account_info,
}))(Form.create({ wrappedComponentRef: true })(Index));



// WEBPACK FOOTER //
// ./src/components/finance/bookInfo/Index.js